module.exports = __webpack_public_path__ + "img/svg/logo-icon.ddbf318ce12f363639d5282dbef06768.svg";